import React, { Component } from "react";
import { Redirect, Link } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Icon from "react-icons-kit";
import { eye } from "react-icons-kit/fa/eye";
import { eyeSlash } from "react-icons-kit/fa/eyeSlash";
import "./Profile.scss";
import { withTranslation } from "react-i18next";

class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: true,
      loggedIn: false,
      error: null,
      loaderUpload: false,
      loaderButton: false,
      loading: false,
      oldPassword: "",
      newPassword: "",
      showpassword: false,
      showpasswordnew: false,
    };
  }

  componentDidMount() {}

  componentWillMount() {}

  showPassword = () => {
    this.setState({ showpassword: !this.state.showpassword });
  };
  showPasswordNew = () => {
    this.setState({ showpasswordnew: !this.state.showpasswordnew });
  };
  changePassword = (e) => {
    e.preventDefault();
    this.setState({ loaderButton: true });
    let data = {
      oldPassword: this.state.oldPassword,
      newPassword: this.state.newPassword,
    };
    if (this.state.newPassword && this.state.newPassword.length > 5) {
      axios({
        method: "put",
        url: process.env.REACT_APP_API_HOST + "/profile/user/change-password",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      }).then(
        (response) => {
          if (response.data.status) {
            // localStorage.setItem('userData', JSON.stringify(response.data.data));
            setTimeout(() => {
              toast.success("Success! Password telah diubah");
              this.setState({ loaderButton: false });
            }, 1000);
          } else {
            if (response.data.error.length) {
              for (var er = 0; er < response.data.error.length; er++) {
                var obj = response.data.error[er];
                for (var key in obj) {
                  console.log(key, obj[key]);
                  toast.error(key + " : " + obj[key]);
                }
                this.setState({ loaderButton: false });
              }
            } else {
              this.setState({ loaderButton: false });
              toast.error(response.data.error);
            }
          }
        },
        (error) => {
          toast.error("Error! " + error);
          setTimeout(() => {
            this.setState({ loaderButton: false });
          }, 1000);
        }
      );
    } else {
      this.setState({ loaderButton: false });
      toast.error("Password harus 6 character atau lebih");
    }
  };

  render() {
    if (!localStorage.getItem("userData")) {
      return <Redirect to={"/"} />;
    }
    return (
      <React.Fragment>
        <div className="nav nav-main-bottom shadow-bottom">
          <div className="container">
            <div className="row align-items-center">
              <div className="col">
                <ul className="nav-tab">
                  <li>
                    <Link data-menu="profile" to="/profile">
                      {this.props.t("ChangePassword.link_profil")}
                    </Link>
                  </li>
                  <li className="active">
                    <Link data-menu="changepassword" to="#">
                      {this.props.t("ChangePassword.link_ubahPassword")}
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="mpl-page login">
          <ToastContainer />
          {this.state.loading === true ? (
            <div className="text-center">
              {this.props.t("ChangePassword.text_mengambilData")}
            </div>
          ) : (
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-sm-12 col-md-5">
                  <h3 className="mt-0">
                    {this.props.t("ChangePassword.text_ubahPassword")}
                  </h3>
                  <form id="formUpdate" onSubmit={this.changePassword}>
                    <div className="row">
                      <div className="col">
                        <div className="form-group">
                          <label htmlFor="" className="label-group">
                            {this.props.t("ChangePassword.label_passwordLama")}
                          </label>
                          {this.state.showpassword ? (
                            <div className="field-group-input">
                              <input
                                type="text"
                                className="field-group small-input"
                                onChange={(e) =>
                                  this.setState({ oldPassword: e.target.value })
                                }
                                value={this.state.oldPassword || ""}
                              />
                              <div className="icon-group">
                                <Icon
                                  size={24}
                                  icon={eye}
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    this.showPassword();
                                  }}
                                />
                              </div>
                            </div>
                          ) : (
                            <div className="field-group-input">
                              <input
                                type="password"
                                className="field-group small-input"
                                onChange={(e) =>
                                  this.setState({ oldPassword: e.target.value })
                                }
                                value={this.state.oldPassword || ""}
                              />
                              <div className="icon-group">
                                <Icon
                                  size={24}
                                  icon={eyeSlash}
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    this.showPassword();
                                  }}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                        <div className="form-group">
                          <label htmlFor="" className="label-group">
                            {this.props.t("ChangePassword.label_passwordBaru")}
                          </label>
                          {this.state.showpasswordnew ? (
                            <div className="field-group-input">
                              <input
                                type="text"
                                className="field-group small-input"
                                onChange={(e) =>
                                  this.setState({ newPassword: e.target.value })
                                }
                                value={this.state.newPassword || ""}
                              />
                              <div className="icon-group">
                                <Icon
                                  size={24}
                                  icon={eye}
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    this.showPasswordNew();
                                  }}
                                />
                              </div>
                            </div>
                          ) : (
                            <div className="field-group-input">
                              <input
                                type="password"
                                className="field-group small-input"
                                onChange={(e) =>
                                  this.setState({ newPassword: e.target.value })
                                }
                                value={this.state.newPassword || ""}
                              />
                              <div className="icon-group">
                                <Icon
                                  size={24}
                                  icon={eyeSlash}
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    this.showPasswordNew();
                                  }}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <button
                          className="btn btn-green float-right"
                          type="submit"
                        >
                          {this.state.loaderButton === true ? (
                            <span>
                              <i className="fa fa-spin fa-spinner"></i>{" "}
                              {this.props.t("ChangePassword.btn_tunggu")}
                            </span>
                          ) : (
                            <span>
                              {" "}
                              <i className="fa fa-save"></i>{" "}
                              {this.props.t("ChangePassword.btn_ubahPassword")}
                            </span>
                          )}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }
}

export default withTranslation()(ChangePassword);
